export const FirstLetterUppercase = (word) => {
    if (!word) return '';
    const str = String(word);
    const firstLetter = str.at(0).toUpperCase();
    const newWord = firstLetter + str.slice(1);
    return newWord;
}